import { useTranslation } from 'react-i18next';

import { useUsd } from '@/hooks/useUsd';

import { LAYER_FILL_CLASS, LAYER_FILL_FALLBACK } from './Costs.constants';
import { styles } from './Costs.styles';
import type { LayerBarProps } from './Costs.types';
import { layerDisplays, unpricedLayerCount } from './Costs.utils';

export const LayerBar = ({ layers }: LayerBarProps) => {
	const { t } = useTranslation('translation', { keyPrefix: 'costs' });
	const usd = useUsd();
	const displays = layerDisplays(layers, t);
	const unpriced = unpricedLayerCount(layers);

	if (displays.length === 0) {
		return <p className={styles.unpricedNote}>{t('LAYER_UNPRICED_NOTE', { count: unpriced })}</p>;
	}

	return (
		<>
			<div className={styles.stack} aria-hidden="true">
				{displays.map((layer) => (
					<div
						key={layer.component}
						className={LAYER_FILL_CLASS[layer.component] ?? LAYER_FILL_FALLBACK}
						style={{ width: `${layer.widthPct}%` }}
						title={`${layer.label}: ${usd.total(layer.costUsd)}`}
					/>
				))}
			</div>
			<ul className={styles.legend}>
				{displays.map((layer) => (
					<li key={layer.component} className={styles.legendItem}>
						<span
							className={`${styles.legendDot} ${LAYER_FILL_CLASS[layer.component] ?? LAYER_FILL_FALLBACK}`}
							aria-hidden
						/>
						{layer.label} · {usd.total(layer.costUsd)}
					</li>
				))}
			</ul>
			{unpriced > 0 && <p className={styles.unpricedNote}>{t('LAYER_UNPRICED_NOTE', { count: unpriced })}</p>}
		</>
	);
};
